import { render } from "./SymptomSelectView.vue?vue&type=template&id=ba773fe2&scoped=true"
import script from "./SymptomSelectView.vue?vue&type=script&lang=js"
export * from "./SymptomSelectView.vue?vue&type=script&lang=js"

import "./SymptomSelectView.vue?vue&type=style&index=0&id=ba773fe2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba773fe2"]])

export default __exports__